import React from 'react';
import { AbsenceDetail } from '@/components/Dashboard/AbsenceDetail';
import type { AbsenceDetailSelection } from '@/components/Dashboard/AbsencesModal';
import { TileModal } from '@/components/Dashboard/TileModal';

interface Props {
  selection?: AbsenceDetailSelection;
  onClose: () => void;
}

export const AbsenceDetailModal: React.FC<Props> = ({ selection, onClose }) => (
  <TileModal
    isOpen={!!selection}
    title={selection?.absence.disciplineName ?? ''}
    onClose={onClose}
  >
    {selection && <AbsenceDetail nonAttendance={selection.absence} />}
  </TileModal>
);
